module.exports = __webpack_public_path__ + "0a0c45cf.png";